export default "__VITE_ASSET__BmNCc677__"